import React from 'react'
import './CheckCashingView.scss'
import {STEPS} from "../../../../constants";
import _ from 'lodash'

import CONFIG from '../../../../config'

import {
  Grid,
  Header,
} from 'semantic-ui-react'

import Navigation from '../../shared/Navigation/containers/NavigationContainer'
import CreateCustomer from '../containers/CreateCustomerContainer'
import CustomerCard from '../containers/CustomerCardContainer'
import CheckCustomer from '../containers/CheckCustomerContainer'
import TransactionStatus from '../containers/CheckCashingTranStatusContainer'
import ReviewOrder from '../containers/CheckReviewContainer'

class CheckCashing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  async componentDidMount(){
    const { appSetObj } = this.props;

    await appSetObj({
      dispensable_amount: Number.MAX_SAFE_INTEGER,
      selected_amount: Number.MAX_SAFE_INTEGER,
    }, true)
  }

  async componentDidUpdate(prevProps, prevState) {
    const {changeMayaNumber, resetMayaCustomer, initMayaCustomer, s_customer_cell_phone} = this.props;

    // FIXME: Dirty hack with using service customer cell phone for maya customer initializing

    if (prevState.s_customer_ready !== this.state.s_customer_ready) {
      await changeMayaNumber(s_customer_cell_phone);

      if(this.state.s_customer_ready){
        await initMayaCustomer();
      } else {
        await resetMayaCustomer();
      }
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if(!_.has(nextProps, 's_customer_ready')) return null;

    if (nextProps.s_customer_ready !== prevState.s_customer_ready) {
      return {s_customer_ready: nextProps.s_customer_ready};
    }

    else return null;
  }

  render() {
    const { title, icon, s_customer_ready, customer_ready, ready_to_review, changeStep } = this.props;

    if(ready_to_review){
      return (
        <Grid columns='equal'>
          <Grid.Row divided style={{'minHeight': 250}} stretched columns={1}>
            <Grid.Column>
              <ReviewOrder />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      )
    }

    return (
      <Grid columns='equal'>
        <Grid.Row divided style={{'minHeight': 250}} stretched columns={2}>

          <Grid.Column>
            <Grid.Row columns={2}>
              <Grid.Column>
                <Header image={`${CONFIG.STATIC_PATH}${icon}`} content={title} as='h3'/>
              </Grid.Column>
              <Grid.Column>
                <Grid.Row>
                  <Grid.Column>
                    {s_customer_ready ? <CustomerCard /> :  <CreateCustomer />}
                  </Grid.Column>
                </Grid.Row>
              </Grid.Column>
            </Grid.Row>
          </Grid.Column>

          <Grid.Column>
            <Grid.Row columns={2}>
              <Grid.Column>
                <TransactionStatus />
              </Grid.Column>
              <Grid.Column>
                {s_customer_ready && customer_ready ? <CheckCustomer /> :  null}
              </Grid.Column>
            </Grid.Row>

          </Grid.Column>

        </Grid.Row>

        <Navigation
          onBackCustom={() => changeStep(STEPS.CATEGORIES)}
          showSubmit={false}
        />

      </Grid>
    )
  }

}

export default CheckCashing;


// WEBPACK FOOTER //
// ./src/components/Applications/CheckCashing/components/CheckCashingView.js